/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataLoaderParamsBasic } from '../models/DataLoaderParamsBasic';
import type { VendorLevelProfile } from '../models/VendorLevelProfile';
import type { VendorLevelProfileCreateRequest } from '../models/VendorLevelProfileCreateRequest';
import type { VendorLevelProfileIdGetReportUrlResponse } from '../models/VendorLevelProfileIdGetReportUrlResponse';
import type { VendorLevelProfileType } from '../models/VendorLevelProfileType';
import type { VendorLevelProfileUpdateRequest } from '../models/VendorLevelProfileUpdateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminVendorLevelProfileService {

    /**
     * get list of VendorLevelProfiles
     * @returns VendorLevelProfile Success
     * @throws ApiError
     */
    public static listAdminVendorLevelProfiles({
        surveyVendorId,
        type,
        limit,
        offset,
        ignorePagination,
        search,
    }: {
        /**
         * Survey Vendor ID
         */
        surveyVendorId?: (number | string | null),
        /**
         * Vendor Level Type
         */
        type?: VendorLevelProfileType,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * ignore Pagination flag
         */
        ignorePagination?: boolean,
        /**
         * Search by name or code
         */
        search?: string,
    }): CancelablePromise<Array<VendorLevelProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/vendorLevelProfile',
            query: {
                'surveyVendorId': surveyVendorId,
                'type': type,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create VendorLevelProfile
     * @returns any Success
     * @throws ApiError
     */
    public static createVendorLevelProfile({
        requestBody,
    }: {
        requestBody?: VendorLevelProfileCreateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/vendorLevelProfile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit VendorLevelProfile
     * @returns VendorLevelProfile Success
     * @throws ApiError
     */
    public static editVendorLevelProfile({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: VendorLevelProfileUpdateRequest,
    }): CancelablePromise<VendorLevelProfile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/vendorLevelProfile/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete VendorLevelProfile
     * @returns any Success
     * @throws ApiError
     */
    public static deleteVendorLevelProfile({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/vendorLevelProfile/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Append VendorLevelProfile file
     * @returns any Success
     * @throws ApiError
     */
    public static appendVendorLevelProfileFile({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: DataLoaderParamsBasic,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/vendorLevelProfile/{id}/append',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Download VendorLevelProfile file
     * @returns string Success
     * @throws ApiError
     */
    public static downloadVendorLevelProfileFile({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/vendorLevelProfile/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reload VendorLevelProfile
     * @returns any Success
     * @throws ApiError
     */
    public static reloadVendorLevelProfile({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: DataLoaderParamsBasic,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/vendorLevelProfile/{id}/reload',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get VendorLevelProfile report url
     * @returns VendorLevelProfileIdGetReportUrlResponse Success
     * @throws ApiError
     */
    public static getVendorLevelProfileFileReportUrl({
        id,
    }: {
        /**
         * Vendor Level Profile ID
         */
        id: string,
    }): CancelablePromise<VendorLevelProfileIdGetReportUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/vendorLevelProfile/{id}/getReportUrl',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
